import angular from 'angular';

import RwDateComponent from './rw-date-component';

export default angular.module('rw-date', []).component('rwDate', new RwDateComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-date/rw-date-module.js